import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Output, ViewChild, ChangeDetectionStrategy, Input, OnInit, HostBinding, AfterViewInit } from '@angular/core';
import { fromEvent } from 'rxjs';
import { map, filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('true', style({ width: '*' })),
      state('false', style({ width: '0' })),
      transition('true => false', animate('300ms ease-in')),
      transition('false => true', animate('300ms ease-out'))
    ])
  ]
})
export class SearchBarComponent implements OnInit, AfterViewInit {
  @ViewChild('input', { static: false }) inputElement: ElementRef;
  @Input() searchValue;
  @Input() placeholder = '';
  @Input() searchOnEnterOnly = false;
  @Input() showSearchButton = false;
  @Input() mobileCollapsed = false;
  @Output() searchFilter = new EventEmitter<string>();

  searchVisible: boolean;

  @HostBinding('class.with-submit-layout')
  get withSubmitLayout(): boolean {
    return this.showSearchButton && this.searchVisible;
  }

  ngOnInit(): void {
    this.searchVisible = false;

    if (!this.mobileCollapsed && this.searchValue !== '') {
      this.searchVisible = true;
    }
  }

  ngAfterViewInit(): void {
    if (!this.searchOnEnterOnly && this.inputElement?.nativeElement) {
      fromEvent(this.inputElement.nativeElement, 'keyup').pipe(
        map((event: any) => event.target.value),
        filter(res => res.length >= 0),
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe((text: string) => {
          this.searchFilter.emit(text);
      });
    }
  }

  public close(): void {
    this.searchVisible = false;
    this.searchValue = '';
    this.searchFilter.emit('');
    this.placeholder = '';
  }

  public open(): void {
    this.searchVisible = true;
    this.placeholder = '';
    setTimeout(() => this.inputElement?.nativeElement?.focus());
  }

  public onEnter(event: KeyboardEvent): void {
    if (!this.searchOnEnterOnly || event.key !== 'Enter') {
      return;
    }
    this.searchFilter.emit((event.target as HTMLInputElement).value || '');
  }

  public triggerSearch(value?: string): void {
    this.searchFilter.emit(value ?? this.inputElement?.nativeElement?.value ?? '');
  }
}
